import React from "react";
import T from "./../TheTool";

function GUI_InputTextSingle(props) {
	function Label1() {
		// var label1 = props.label;
		// if (label1 == null) {
		// 	label1 = "";
		// }
		// var width1 = props.width1;
		// if (width1 == null) {
		// 	width1 = 200;
		// }
		var label1 = T.getValue(props.label, ""); 
		var label1size = T.getValue(props.labelsize, 24); 
		var width1 = T.getValue(props.width1, 200);
		var labelAlign = T.getValue(props.labelAlign, "left");
		return (
			// <div>
			<div style={{ width: width1 , textAlign: labelAlign }}>
				<label style={{ fontSize: label1size, paddingRight: 20 }}>
					<b>{label1}</b>
				</label>
			</div>
		);
	}

	function Input1() {
		// var text1 = props.text1;
		// if (text1 == null) {
		// 	text1 = "";
		// }
		// var widthSet = false;
		// var width2 = props.width2;
		// if (width2 != null) {
		// 	// width2 = 300;
		// 	widthSet = true;
		// }
		// var fontSize2 = props.fontSize2;
		// if (fontSize2 == "") {
		// 	fontSize2 = 32;
		// }
		var text1 = T.getValue(props.text1, ""); 
		var width2 = props.width2; 
		var widthSet = props.width2 != null ? true : false; 
		var fontSize2 = T.getValue(props.fontSize2, 32); 
		var placeholder = T.getValue(props.placeholder, ""); 
		return (
			<input
				type="text"
				id="input_boxsize"
				className="input input__001"
				name="text"
				autoComplete="off"
				// textAlign={"center"}
				// style={{
				// 	fontSize: 32,
				// 	textAlign: "center",
				// 	// color:'blue'
				// 	// width: width2,
				// }}
				style={
					widthSet
						? { fontSize: fontSize2, textAlign: "center", width: width2 }
						: { fontSize: fontSize2, textAlign: "center" }
				}
				value={text1}
				placeholder={placeholder}
				// onChange={(event) => props.text1Change(event.target.value)}
				// onKeyPress={(event) => {
				// 	if (!/[0-9]/.test(event.key)) {
				// 		event.preventDefault();
				// 	}
				// }}
				onChange={(e) => TextChange(e)}
				onKeyPress={(e) => TextBehavior(e)}
			/>
		);
	}

	function TextChange(event) {
		props.text1Change(event.target.value);
	}

	function TextBehavior(event) {
		if (props.numberOnly) {
			if (!/[0-9]/.test(event.key)) {
				event.preventDefault();
			}
		} else {
		}
	}

	return (
		<form>
			<div
				// class="flexbox-container"
				className="flexbox-container"
				style={{
					alignItems: "center",
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				{Label1()}
				{Input1()}
			</div>
		</form>
	);
}

export default GUI_InputTextSingle;
